// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoBulle_info__2_-H8"};